import React from 'react';
import {
  HiOutlineArrowTrendingUp as EscalationIcon,
  HiOutlineInbox as AllQueriesIcon,
  HiOutlinePlusCircle as RaiseQueryIcon,
  HiOutlineClipboardDocumentList as AssignedQueriesIcon,
  HiOutlineUsers as UsersIcon,
  HiOutlineShieldCheck as RolesIcon,
  HiOutlineChartBar as SLADashboardIcon,
  HiOutlineCog6Tooth as SettingsIcon,
  HiOutlineBriefcase as ProjectIcon,
} from 'react-icons/hi2';

/**
 * Get menu configuration based on user permissions
 * @param {Object} permissions - User permissions object from useUserPermissions hook
 * @returns {Array} Array of menu sections with items
 */
export const getMenuConfig = (permissions) => {
  const {
    isAdmin,
    canViewMyQueries,
    canViewAssignedQueries,
    canViewEscalatedQueries,
  } = permissions;

  // Build query items based on permissions
  const queryItems = [
    ...(isAdmin
      ? [{ name: 'All Queries', icon: <AllQueriesIcon />, path: '/dashboard/queries/all' }]
      : []),
    ...(canViewMyQueries
      ? [{ name: 'My Queries', icon: <RaiseQueryIcon />, path: '/dashboard/queries/raise' }]
      : []),
    ...(canViewAssignedQueries
      ? [{ name: 'Assigned Queries', icon: <AssignedQueriesIcon />, path: '/dashboard/queries/assigned' }]
      : []),
    ...(canViewEscalatedQueries
      ? [{ name: 'Notified Queries', icon: <EscalationIcon />, path: '/dashboard/queries/escalated' }]
      : []),
  ];

  // Build menu sections (PowerBI "Dashboard" removed from sidebar; SLA Dashboard and others kept)
  const menuSections = [
    ...(isAdmin
      ? [{
          title: 'Main',
          items: [
            { name: 'SLA Dashboard', icon: <SLADashboardIcon />, path: '/dashboard/analytics/sla' },
          ],
        }]
      : []
    ),
    {
      title: 'Queries',
      items: queryItems,
    },
    ...(isAdmin
      ? [{
          title: 'Projects',
          items: [
            { name: 'Projects', icon: <ProjectIcon />, path: '/dashboard/projects' },
          ],
        }]
      : []
    ),
    ...(isAdmin
      ? [{
          title: 'Admin',
          items: [
            { name: 'Users', icon: <UsersIcon />, path: '/dashboard/admin/users' },
            { name: 'Roles', icon: <RolesIcon />, path: '/dashboard/admin/roles' },
          ],
        }]
      : []
    ),
    {
      title: 'Settings',
      items: [
        { name: 'Settings', icon: <SettingsIcon />, path: '/dashboard/settings' },
      ],
    },
  ];

  return menuSections;
};
